import {
  addHours,
  addWeeks,
  nextMonday,
  nextSaturday,
  set,
  isAfter,
  roundToNearestMinutes,
  isSaturday,
  isSunday,
  addDays,
  startOfWeek,
} from 'date-fns'

export interface DatePreset {
  label: string
  getDate: (now: Date) => Date
}

export const DATE_PRESETS: Array<DatePreset> = [
  {
    label: 'In 1 hour',
    getDate: (now) => roundToNearestMinutes(addHours(now, 1), { nearestTo: 15, roundingMethod: 'ceil' }),
  },
  {
    label: 'Tonight',
    getDate: (now) => {
      const ninepm = set(now, { hours: 21, minutes: 0, seconds: 0, milliseconds: 0 })
      if (isAfter(now, ninepm)) {
        return roundToNearestMinutes(addHours(now, 1), { nearestTo: 15, roundingMethod: 'ceil' })
      }
      return ninepm
    },
  },
  {
    label: 'This weekend',
    getDate: (now) => {
      const isWeekend = isSaturday(now) || isSunday(now)
      // If already on a weekend, skip to the Saturday of the week after next
      const base = isWeekend ? addWeeks(now, 1) : now
      return set(nextSaturday(base), { hours: 9, minutes: 0, seconds: 0, milliseconds: 0 })
    },
  },
  {
    label: 'Next week',
    getDate: (now) => set(nextMonday(now), { hours: 9, minutes: 0, seconds: 0, milliseconds: 0 }),
  },
  {
    label: 'In 2 weeks',
    getDate: (now) => {
      const twoWeeksOut = addWeeks(now, 2)
      const monday = startOfWeek(twoWeeksOut, { weekStartsOn: 1 })
      return set(monday, { hours: 9, minutes: 0, seconds: 0, milliseconds: 0 })
    },
  },
]
